import React, { useState } from 'react';
import Navbar from '../../containers/Navbar/Navbar';
import style from './Register.module.css';
import {useDispatch } from 'react-redux';
import {registerUser} from '../../../redux/actions/authActions';
import CircularSpinner from '../../utils/CircularSpinner';
import { Link } from 'react-router-dom';


const Register = () => {
    const [username, setUsername] = useState("")
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState("");
    const [failure, setFailure] = useState("");
    const dispatch = useDispatch();

    const registerSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const data = {
            email: email,
            password: password,
            username: username,
        }
        const response = await dispatch(registerUser(data));
        if(response.status === 200) {
            setSuccess("User Successfully Registered !!");
            setFailure("");
        }else{
            const errorMessage = response.data.errorMessage || "Something went wrong !!"
            setSuccess("");
            setFailure(errorMessage);
        }
        setEmail("");
        setPassword("");
        setUsername("");
        setLoading(false);
    }

    return (
        <div className={style.registerContainer}>
           <div className="container">
            <Navbar />
                <div className={`${style.registerForm}`}>
                    <h3 className='text-center'>
                        Register Form
                    </h3>
                    <form onSubmit={registerSubmit}>
                        {
                            success ? 
                            (
                                <div className="alert alert-success alert-dismissible fade show" role="alert">
                                    {success}
                                    <button type="button"  onClick = {() => setSuccess("")} className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                                </div>
                            ) : 
                            <></>
                        }
                        {
                        failure
                        ? (
                            <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                {failure}
                                <button type="button" onClick = {() => setFailure("")} className="btn-close" data-bs-dismiss="alert" aria-label="Close">

                                </button>
                            </div>
                        ) :
                        <></>
                        }
                        <div className='form-group mt-5'>
                            <input className="form-control w-100" 
                            type='username' 
                            placeholder="Enter your username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)} />
                        </div>
                        <div className='form-group mt-5'>
                            <input className="form-control w-100" 
                            type='email' 
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)} />
                        </div>
                        <div className='form-group mt-5'>
                            <input className="form-control w-100"
                            type='password' 
                            value={password}
                            placeholder="Enter your password"
                            
                            onChange={(e) => setPassword(e.target.value)} />
                        </div>
                        <div className='form-group mt-5'>
                            <button className='btn btn-primary w-100' disabled={loading}>
                                {
                                    loading ? 
                                    (
                                        <CircularSpinner/>
                                    ) : 
                                    <strong>Register</strong>
                                }
                            </button>
                        </div>
                        <div className="form-group mt-5">
                            <p style={{textAlign: 'right'}}>
                                Already have an account ? &nbsp;
                                <Link to="/login" style={{color: "#0d6efd"}}>
                                    <strong>Log In</strong>
                                </Link>
                            </p>
                        </div>
                    </form>
                </div>
           </div>
        </div>
    )
}

export default Register;
